import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, MapPin, Smartphone, LogOut, AlertTriangle, Brain, MessageCircle, Flag, } from 'lucide-react';
import { useBackButton } from '../hooks/useTelegram';
const RULES = [
    {
        icon: MapPin,
        color: '#34d399',
        bg: 'rgba(16,185,129,.1)',
        title: 'Публичные места',
        text: 'Всегда встречайтесь в людных, хорошо освещённых местах. Кафе, парки, торговые центры — отличный выбор.',
    },
    {
        icon: Smartphone,
        color: '#60a5fa',
        bg: 'rgba(96,165,250,.1)',
        title: 'Предупредите друга',
        text: 'Скажите кому-то, куда идёте, с кем и во сколько планируете вернуться. Поделитесь геолокацией.',
    },
    {
        icon: LogOut,
        color: '#fb923c',
        bg: 'rgba(251,146,60,.1)',
        title: 'Не понравилось — уходите',
        text: 'Вы не обязаны оставаться, если чувствуете дискомфорт. Вежливо попрощайтесь и уходите.',
    },
    {
        icon: AlertTriangle,
        color: '#f87171',
        bg: 'rgba(248,113,113,.1)',
        title: 'Красные флаги',
        text: 'Давление, настойчивые просьбы ехать к кому-то домой, агрессия, манипуляции — повод уйти немедленно.',
    },
    {
        icon: Brain,
        color: '#a78bfa',
        bg: 'rgba(167,139,250,.1)',
        title: 'Доверяй интуиции',
        text: 'Если что-то кажется неправильным — скорее всего, так и есть. Доверяйте своим ощущениям.',
    },
    {
        icon: MessageCircle,
        color: '#fbbf24',
        bg: 'rgba(251,191,36,.1)',
        title: 'Обратная связь',
        text: 'После встречи оставьте фидбек — это помогает сообществу. Мы ценим честные отзывы.',
    },
    {
        icon: Flag,
        color: '#f87171',
        bg: 'rgba(248,113,113,.1)',
        title: 'Что-то пошло не так?',
        text: 'Напишите нам — мы разберёмся. Безопасность участников — наш главный приоритет.',
    },
];
export function SafetyGuidePage() {
    const navigate = useNavigate();
    useBackButton(() => navigate(-1));
    return (_jsx("div", { className: "absolute inset-0 flex flex-col overflow-y-auto no-scrollbar tg-safe", style: { background: '#0A0A0A' }, children: _jsxs("div", { className: "px-5 pt-4 pb-8", children: [_jsx("button", { className: "btn-back mb-6", onClick: () => navigate(-1), children: _jsx(ArrowLeft, { className: "w-4 h-4" }) }), _jsxs("div", { className: "flex items-center gap-3 mb-6", children: [_jsx("div", { className: "w-12 h-12 rounded-2xl flex items-center justify-center", style: { background: 'rgba(16,185,129,.12)' }, children: _jsx(Shield, { className: "w-6 h-6 text-emerald-400/80" }) }), _jsxs("div", { children: [_jsx("h1", { className: "text-white font-bold text-[20px]", children: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0432\u0441\u0442\u0440\u0435\u0447" }), _jsx("p", { className: "text-white/40 text-[13px]", children: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438" })] })] }), _jsx("div", { className: "space-y-3", children: RULES.map((rule, i) => {
                        const Icon = rule.icon;
                        return (_jsx("div", { className: "rounded-2xl p-4", style: {
                                background: 'rgba(255,255,255,.04)',
                                border: '1px solid rgba(255,255,255,.06)',
                            }, children: _jsxs("div", { className: "flex items-start gap-3.5", children: [_jsx("div", { className: "w-10 h-10 rounded-xl flex items-center justify-center shrink-0 mt-0.5", style: { background: rule.bg }, children: _jsx(Icon, { className: "w-5 h-5", style: { color: rule.color } }) }), _jsxs("div", { children: [_jsx("h3", { className: "font-semibold text-[14px] mb-1", style: { color: rule.color }, children: rule.title }), _jsx("p", { className: "text-white/40 text-[13px] leading-relaxed", children: rule.text })] })] }) }, i));
                    }) })] }) }));
}
